import React from 'react';
import Icon from './Icon';

const Button = ({ isLoading, children,...rest }) => {
  return (
    <button
      disabled={isLoading}
      type="submit"
      {...rest}
      className={`btn btn-primary ${rest.className}`}
    >
      {isLoading && <Icon.Spinner className="animate-spin"/>}
      {isLoading ? <span>Loading...</span> : children}
    </button>
  )
}

export default Button